<script lang="ts">
	import PointTitle from './PointTitle.svelte';
	import Address from './Address.svelte';
	import Gis from '$lib/assets/social_links/2gis.svelte';
	import Google from '$lib/assets/social_links/google.svelte';
	import Instagram from '$lib/assets/social_links/instagram.svelte';
	import Rutube from '$lib/assets/social_links/rutube.svelte';
	import Telegram from '$lib/assets/social_links/telegram.svelte';
	import Vk from '$lib/assets/social_links/vk.svelte';
	import Yandex from '$lib/assets/social_links/yandex.svelte';
	import Youtube from '$lib/assets/social_links/youtube.svelte';
	import bodyClass from '$lib/helpers/bodyClass';
	import { onMount } from 'svelte';
	import Question from './Question.svelte';
	import MadeInQrot from '$lib/assets/logo/madeinqrot.svelte';
	import Ball from '$lib/assets/animation/ball.svg?raw';
	import QrotWallet from '$lib/assets/logo/qrot_wallet.svelte';
	export let point: any;
	export let link_nanoid: any = null;
	export let sticker_nanoid: any = null;
	export let cookiesQuestions: any;
	export let is_subscription: boolean;
	$: is_subscription;

	export let bg: string | null;
	let buttons = point.buttons ?? [];
	let social_links = point.social_links ?? [];

	let rating_data: number = 0;
	$: rating_data;
	$: point;

	let primary_color = point.primary_color as string;
	export let color = '#000';

	const classFoo = bodyClass('body_shows', color);
	let toggleBody = false;
	onMount(() => {
		toggleBody = true;
	});

	const handleAnswer = async (event: any) => {
		let { answer_id, question_id } = event.detail;

		let response = await fetch('/api/questions/answer', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				point_nanoid: point.nanoid,
				answer_id,
				question_id
			})
		});

		if (response.ok) {
			point.questions = point?.questions?.filter((question: any) => question.id !== question_id);
		}
	};
</script>

<!-- <div class="w-20 bg-white">
	<span class="my-icon">{@html Ball}</span>
</div> -->

<svelte:body use:classFoo={toggleBody} />

<div class="md:max-w-96 {point.is_dark ? 'text-base-200' : ''}" style="--bg-img: url({bg ?? ''})">
	<div class="absolute top-0 bg-image right-0 left-0 bottom-0 -z-10"></div>
	<div
		class="absolute top-0 grad right-0 left-0 h-full -z-10"
		style="background:
	linear-gradient(to bottom, {color} 0%, {color}00 10%, {color}00 90%, {color} 100%);"
	></div>
	<div class="h-1"></div>
	<div class="flex flex-col rounded-2xl py-4 px-6 mx-2">
		{#if point.nanoid}
			<div class="pt-3"></div>
			<PointTitle text={point.name ?? ''} />
			<Address text={point.address ?? ''} />
			<div class="pb-4"></div>

			{#if point.content}
				<div class="pb-4 flex justify-center--">
					<div class="  font-normal text-center--">
						<p class="max-w-[30ch] leading-5 break-words">{point.content}</p>
					</div>
				</div>
			{:else}{/if}
		{/if}

		{#if point.nanoid}
			{#if social_links?.length > 0}
				<div class="flex justify-center-- pt-4 pb-10">
					<div class=" grid grid-cols-2 gap-3">
						{#each social_links as link}
							<div class="flex items-center gap-1">
								<a href={link.url} class="h-5 w-5">
									<!-- <div class="h-5 w-5 mr-1"> -->
									{#if link.name == '2gis'}
										<svelte:component this={Gis} />
									{:else if link.name == 'google'}
										<svelte:component this={Google} />
									{:else if link.name == 'instagram'}
										<svelte:component this={Instagram} />
									{:else if link.name == 'rutube'}
										<svelte:component this={Rutube} />
									{:else if link.name == 'telegram'}
										<svelte:component this={Telegram} />
									{:else if link.name == 'vk'}
										<svelte:component this={Vk} />
									{:else if link.name == 'yandex'}
										<svelte:component this={Yandex} />
									{:else if link.name == 'youtube'}
										<svelte:component this={Youtube} />
									{/if}
								</a>
								<!-- </a> -->
								<a href={link.url} class="">
									<div class="text-sm font-medium underline hover:no-underline">
										{link.title}
									</div>
								</a>
							</div>
						{/each}
					</div>
				</div>
			{/if}
		{/if}
		<div class="flex justify-center flex-col">
			{#each buttons as item, id}
				{#if id !== 0 && item.title}
					<a
						data-sveltekit-reload
						href={item.url}
						class="hover:opacity-90 {point.is_dark
							? ' bg-white/10'
							: ' bg-white/30'} text-center font-medium px-4 py-[0.9rem] rounded-xl mb-2"
					>
						{item.title}
					</a>
				{/if}
			{/each}
			{#each buttons as item, id}
				{#if id == 0 && item.title}
					<a 
					data-sveltekit-reload
						href={item.url}
						style="background-color: {primary_color ?? '#3a3836'};"
						class="hover:opacity-90 text-center font-medium px-4 py-[0.9rem] text-white rounded-xl mb-1"
					>
						{item.title}
					</a >
				{/if}
			{/each}
		</div>
	</div>
	<!-- {#if !is_subscription} -->
	<div class="pt-8">
		<a href="https://t.me/qrotlinkbot?start={link_nanoid ?? '-s-' + sticker_nanoid}" target="_blank">
			<div class="flex items-center justify-center">
				<!-- style="
				color: {point.is_dark ? primary_color : primary_color ?? '#3a3836'};" -->
				<div
				class="w-36- px-4 py-4
				hover:bg-white hover:text-primary-500 hover:border-white
				{point.is_dark ? 'text-white border-white/20' : 'text-base-950/75 border-base-950/20'}
				rounded-full border-[1px]"
				>
				<!-- <MadeInQrot /> -->
				 <div class="w-5">

					 <QrotWallet />
				 </div>
			</div>
			<!-- Сохранить ссылку -->
			</div>
		</a>
	</div>
	<!-- {/if} -->
	{#if point.questions}
		<!-- {cookiesQuestions} -->
		<Question
			{is_subscription}
			is_dark={point.is_dark}
			on:answer={handleAnswer}
			{cookiesQuestions}
			questions={point.questions}
		/>
	{/if}
</div>

<style>
	.bg-image {
		background:
			/* linear-gradient(to bottom, rgba(241, 239, 238, 0), rgba(241, 239, 238, 0)), */ var(
				--bg-img
			)
			no-repeat;
		background-size: 100% 100%;
		background-attachment: cover;
	}
	/* .grad {
		background: rgb(241, 239, 238);
		background: linear-gradient(180deg, #ffffff50 0px, #f4f3eb70 90px, #f4f3eb 400px);
	} */

	/* :global(body) {
		background-color: var(--color);
		/* background-color: aqua; 
	} */
</style>
